import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { apiGetmiddleuserbyid, deletelastrecentdata } from '@/port/admins/instrument'
import { isValidateapprovaltimeswitch } from '@/components/schoolInstrument/mixins/utils'
import { getwebsiteapproval, getapprovaldashboard } from '@/port/pages/webSite.js'
import { outhreflogin, getaccesstoken } from '@/port/pages/login'
import { ref } from 'vue'
import { getappperAuthority } from "@/port/schoolInstrument/appConfig";
import { goAppId } from '@/util/util'
import { getInsideScreenParam, getOtherLinked } from '@/components/schoolInstrument/component/mutual/common/config'
import { getCustomVal } from '@/util/customData'
import { filterSymbol } from '@/api/instrumentControl'
import { markdownToHtml, markdownToText } from '@/api/global'
import { generateTime, generateTime10, generateTime60 } from "@/api/utils";
import { getfilecontent } from '@/port/admins/ai'
import { cloneDeep } from 'lodash'
import qs from 'qs'


const purviewObj = {
  11: 'approvalid',
  1: 'myreportformid',
  2: 'myreportformid',
  3: 'myreportformid',
  4: 'myreportformid',
  5: 'myreportformid',
  27: 'myreportformid',
  6: 'scopeid',
  7: 'reportFormid',
  8: 'uncompleteid',
  12: 'approvalid',
  14: 'reportFormid',
  16: 'reportFormid',
  18: 'reportFormid',
  28: 'reportFormid',
  15: 'myreportformid',
  17: 'myreportformid',
  13: 'myreportformid',
  23: 'myreportformid',
  24: 'myreportformid',
}

const time30 = generateTime()
const time60 = generateTime60()
const time10 = generateTime10()
const TIME_10_30_60 = {
  10: time10,
  30: time30,
  60: time60
}
export const useInside = (props, emit) => {

  const route = useRoute()
  const skey = route.query.skey || route.params.skey
  const isUpace = Boolean(route.query.upaceid)
  const isSpace = Boolean(route.query.spaceid)
  const dialogInfo = ref({
    dialogName: '新增',
    dialogWidth: '1700px',
    dialogHeight: '800px',
    isVisible: false
  })
  const addInputShow = ref(false)
  const openfunctionValue = ref({})
  const openInputValue = ref({})
  const appId = ref('')
  const iIdValue = ref('')
  const importConfig = ref({})
  const importData = ref({})

  const getAppInfo = async (id, type = 1) => {
    let fn = getwebsiteapproval
    let _par = {
      skey: skey,
    }
    if (type === 5) {
      fn = getapprovaldashboard
      _par.approvalDashboardId = id
    } else {
      _par.approvalId = id
    }
    const res = await fn(_par)
    if (res.code === 0) {
      if (res.data.status === 0) {
        return false
      }
      return res.data.openfunction
    }
  }

  const getfileCont = async (file) => {
    const resFile = await getfilecontent({
      path: file
    })
    if (resFile.code === 0) {
      return resFile.data
    }
    else {
      ElMessage.error(resFile.msg)
      return false
    }
  }

  const getWebsiteUserInfo = async (iId) => {
    if (iId !== 11) return
    const skey = route.params.skey || route.query.skey
    if (!skey) return
    let accesstoken = ''
    for (let i = 0; i < 6; i++) {
      accesstoken += Math.floor(Math.random() * 10);
    }
    const { data, code } = await outhreflogin({ skey, accesstoken })
    if (code === 0) {
      let date = {
        schoolId: data.listschool[0].schoolId,
        openId: data.userId,
        accesstoken: accesstoken
      }
      const res = await getaccesstoken(date)
      if (res.code === 0) {
        const user = res.data
        localStorage.setItem('visitorUser', JSON.stringify(user))
      }
    }
  }
  const getDefaultObj = (info, data) => {
    const defaultObj = {}
    if (info && info.linked) {
      info.linked.forEach(link => {
        if (link.datatype === 'custom') {
          const filed = link.FormList.find(iten => { return link.conditionValue === iten.name })
          if (filed) {
            const key = `${filed.title}_${filed.type}`
            if (filed.datatype !== 'custom' && data[key]) {
              defaultObj[key] = data[key]
            }
          }
        }
      })
    }
    return defaultObj
  }
  // 获取当前需要打开的 url
  const getOpenUrl = async (item, type) => {
    let str = item.url
    switch (item.link) {
      case 1:
        break
      case 2:
        if (type === 'detailed') {
          if (item.datatype === 7) {
            // 7 是报表应用
            str = `/clientSide/reportView/?reportId=${item.appid}`
          } else if (item.datatype === 8) {
            // 8 是 ai小易
            str = `/chat?aiModelId=${item.appid}`
          } else if (item.datatype === 5) {
            // 5 是 仪表盘的
            str = `/clientSide/instrument/instrument?dataReportId=${item.appid}&showSearch=true`
            if (item.open === 4) str += 'navShow=true'
          } else if (item.datatype === 2 && !skey) {
            str = await getApper(item)
            if (str === false) return false
          } else {
            const obs = {
              approvalId: item.appid,
              iId: item.appIid,
              source: 'user',
              name: item.appName,
              navShow: false
            }
            obs[goAppId[item.appIid]] = item.appIid
            // 提交统计走另外的 url
            if (item.appIid === 8) {
              str = `/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?${qs.stringify(obs)}`
            } else if (item.appIid === 27 || item.appIid === 28) {
              str = `/clientSide/workbench/TMbulkImport?${qs.stringify(obs)}&bulkImportMutat=${item.appIid === 28}`
            } else {
              str = `/clientSide/application?${qs.stringify(obs)}`
            }
          }
        } else if (item.datatype && item.datatype === 2 && !skey) {
          str = await getApper(item)
          if (str === false) {
            return false
          }
        } else if (item.datatype && item.datatype === 8) {
          str = `/chat?aiModelId=${item.appid}`
        } else {
          str = `/clientSide/application?approvalId=${item.appid}&source=user&name=${item.appName}`
          if (item.open === 2 || item.open === 5) str += '&navShow=false'
        }
        break
    }
    if (item.link === 2) {
      // 应用的话单独配置
      console.log('应用的单独配置1', item, item.linked)
      let obs = {}
      let paramsLists = []
      // 类似表单数据一样的传参
      const paramsListType2 = []
      if (item.listValue && item.listValue.length > 0) {
        let date = []
        for (const ele of item.listValue) {
          const data = await getObs(item, ele)
          if (data.paramsLists?.length > 0) {
            const obj = {}
            data.paramsLists.forEach(item => [
              obj[item.name] = item.value
            ])
            paramsListType2.push(obj)
            date.push(data.obs)
            paramsLists = paramsLists.concat(data.paramsLists)
          }

        }
        obs = date
      } else {
        const data = await getObs(item, item.value)
        console.log("data==", data);

        obs = data.obs
        paramsLists = data.paramsLists || []
        if (paramsLists.length > 0) {
          const obj = {}
          paramsLists.forEach(item => [
            obj[item.name] = item.value
          ])
          paramsListType2.push(obj)
        }
      }
      if ([27, 28].includes(item.appIid) && obs) {
        // 处理导入的默认值覆盖
        const val = Array.isArray(obs) ? obs[0] || {} : obs
        localStorage.setItem('TMbulkImportObs', JSON.stringify([val]))
        const defaultObj = getDefaultObj(item, val) || {}

        if (Object.keys(defaultObj).length > 0) {
          localStorage.setItem('defaultDataObs', JSON.stringify(defaultObj))
        }
      }
      if (item.channel && item.channel === 'appAi') {
        str += '&channel=appAi'
        // 如果传参有值，则直接赋值
        if (item.linked && item.linked.length > 0) {
          let linkedFormdata = {};
          item.linked.forEach(linkedField => {
            if (linkedField.value) {
              const matchingRule = linkedField.FormList.find(rule => rule.name === linkedField.conditionValue);
              linkedFormdata[matchingRule.title + '_' + matchingRule.type] = linkedField.value;
            }
          });
          str += `&customData=${JSON.stringify(linkedFormdata)}`
        }
      }
      if (JSON.stringify(obs) !== '{}' && ![27, 28].includes(item.appIid)) {
        str += `&search=${JSON.stringify(obs)}`
      }
      if (paramsLists.length > 0) {
        str += `&paramsList=${JSON.stringify(paramsLists)}`
      }
      if (item.datatype === 8 && paramsListType2.length > 0) {
        str += `&paramsListType2=${JSON.stringify(paramsListType2)}`
      }
      console.log('应用的单独配置返回', str, obs, item, item.datatype === 2, paramsListType2)
    } else {
      const obs = {}
      for (const i of item.customize) {
        let val = item.value[i.title || i.name]
        if (i.type === 'relation-user' && typeof val === "object") {
          if (i.format === 'userId' || i.format === 'realname') {
            val = Array.isArray(val) ? val.map(its => its[i.format]).join(',') : val[i.format]
          } else {
            const user = await getUserInfo(val.userId)
            val = user[i.format]
          }
        } else if (i.type === 'date') {
          val = await getTime(val, i.format)
        }
        if (i.parameter) {
          obs[i.parameter] = val
        } else {
          if (item.link !== 3) {
            const typeI = i.FormList.findIndex(its => {
              return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
            })

            const typeObj = i.FormList[typeI]

            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
            obs[type] = val || ''
          } else {
            obs[i.title + '_' + i.type] = val
          }
        }
      }
      const obsStr = qs.stringify(obs)
      let strName = '?'
      if (item.link === 3 && item.url && item.url.includes('?')) strName = '&'
      if (obsStr) str += (strName + obsStr)
    }
    if (route.query.upaceid) {
      str += '&upaceid=' + route.query.upaceid
    }
    return str
  }

  const getObs = async (item, value) => {
    let obs = {}
    // const screenLinked = item.linked.filter(f => f.orgName === 'screen')
    // const filedLinked = item.linked.filter(f => f.orgName !== 'screen')
    const screenLinked = []
    const filedLinked = []
    const otherLinked = []
    for (const i of item.linked) {
      if (i.orgName === 'screen') {
        screenLinked.push(i)
      } else if (i.orgName === 'filed' || i.orgName === undefined) {
        filedLinked.push(i)
      } else {
        otherLinked.push(i)
      }
    }
    if (otherLinked.length !== 0) {
      const obj = getOtherLinked({ linked: otherLinked, currentOrg: props.currentOrg, currentUser: props.currentUser })
      obs = { ...obs, ...obj }
    }
    if (screenLinked.length !== 0) {
      const screens = (props.screenRef && props.screenRef.length > 0 ? props.screenRef : props.$refs.screenRef) || []
      if (props.otherToolScreenRef && props.otherToolScreenRef.length > 0) {
        screens.push(...props.otherToolScreenRef)
      }
      const currentOrg = props.currentOrg
      const customData = props.customData
      obs = { ...obs, ...getInsideScreenParam({ screenLinked, screens, currentOrg, customData, orgList: props.orgList }) }
    }

    const paramsLists = []

    for (const key in obs) {
      if (key.includes('_custom')) {
        const obj = {
          name: key.split('_')[0],
          value: obs[key]
        }
        paramsLists.push(obj)
        delete obs[key]
      }
    }
    for (const i of filedLinked) {
      let val = ''
      if (i.datatype === 'custom') {
        // 自定义的变量
        val = getCustomVal(i)
      } else {
        val = value[i.title || i.name] || value[i.title] || value[i.name]
        // 如果配置解析数据，缓存它的值(解析数据的值可能超过url传参的限制)
        if (i.title === 'data-analysis') {
          val = 'dataAnalysisStorage'
          localStorage.setItem('dataAnalysisStorage', value[i.title])
        }
        else if (item.channel && item.channel === 'appAi') {
          // 配置了文件解析并打开
          if (i.type === 'file') {
            console.log("aaaqq===", i.type, i, props.ruleList)
            for (const itemSub of props.ruleList) {
              if (itemSub.type === 'file' && itemSub.title === i.title && itemSub.analysis) {
                console.log("aaaqq===", itemSub.type, i.value);

                if (i.value && i.value.length > 0) {
                  let fileVal = '';

                  for (const file of i.value) {
                    if (file.response) {
                      const fileName = file.response.replace(/^\/userfiles\//, '');
                      console.log("fileName==", fileName, props.ruleList);

                      const fileContent = await getfileCont(fileName);
                      // 只有当 fileContent 不是 false 时才累加
                      if (fileContent !== false) {
                        fileVal += fileContent;
                      }
                      else return
                    }
                  }

                  val = 'fileAnalysisStorage';
                  localStorage.setItem('fileAnalysisStorage', fileVal);
                }
              }
            }
          }
          else {
            val = value[i.title + '_' + i.type]
          }
        }

      }
      if (i.type === 'relation-user') {
        // 如果是发起相关，直接返回数据
        if (typeof val === "object") {
          if (item.appIid === 12 || item.appIid === 11) {
            // TODO
          } else {
            if (i.format) {
              if (i.format === 'userId' || i.format === 'realname') {
                const s = val
                if (Array.isArray(s)) {
                  val = s.map(its => its[i.format])
                } else {
                  val = val[i.format]
                }
              } else {
                const userArr = val
                if (Array.isArray(userArr)) {
                  const userArrFromat = []
                  for (const e of userArr) {
                    console.log('联系人查询', e)
                    const user = await getUserInfo(e.userId)
                    userArrFromat.push(user[i.format || 'realname'])
                  }
                  val = userArrFromat
                  // val = userArrFromat.join(',')
                } else {
                  const user = await getUserInfo(val.userId)
                  val = user[i.format]
                }
              }
            }
          }
        } else if (i.title === '申请人' && i.name === '申请人') {
          val = [{
            realname: val,
            userId: value.userId
          }]
        }
      } else if (i.type === 'date') {
        val = await getTime(val, i.format)
      } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
        val = value[filterSymbol(i.title)]
        if (val && i.type === 'dates') val = val.split(',')
      } else if (i.type === 'image' && Array.isArray(val)) {
        val = JSON.stringify(val)
      }
      const typeI = i.FormList.findIndex(its => {
        let isCustom = false
        if (i.conditionValue && i.conditionValue.search('custom') !== -1) {
          isCustom = true
        }
        const name = i.conditionValue && i.conditionValue.search('custom') !== -1 ? i.conditionValue.split('_')[0] : i.conditionValue
        return isCustom ? its.name === name && its.datatype === 'custom' : its.name === name
      })
      const typeObj = i.FormList[typeI]
      if (typeObj.datatype === 'custom') {
        if (item.datatype === 7 && i.datatype !== 'custom' && Array.isArray(item.detailValue) && item.detailValue.length > 0) {
          let valList = []
          item.detailValue.forEach(iter => {
            const data = iter[i.title || i.name] || iter[i.title] || iter[i.name]
            Array.isArray(data) ? valList.push(...data) : valList.push(data)
          })
          valList = valList.filter(iter => { return iter || iter === 0 })
          paramsLists.push({ name: typeObj.name, value: valList.length > 0 ? valList : '' })
        } else {
          paramsLists.push({ name: typeObj.name, value: val || '' })
        }
      } else {
        const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
        obs[type] = val || ''
      }
    }
    for (const i of item.customize) {
      let val = value[i.title || i.name]
      if (i.type === 'relation-user' && typeof val === "object") {
        if (i.format) {
          if (i.format === 'userId' || i.format === 'realname') {
            val = val[i.format]
          } else {
            const user = await getUserInfo(val.userId)
            val = user[i.format]
          }
        }
      } else if (i.type === 'date') {
        val = await getTime(val, i.format)
      } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
        val = value[filterSymbol(i.title)]
        if (val && i.type === 'dates') val = val.split(',')
      }
      if (item.datatype === 5) {
        // 仪表盘另外算
        let types = ''
        const formItem = i.FormList[i.index]
        if (formItem && formItem.datatype !== 'custom') {
          types = formItem.i
          if (obs[types]) {
            const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
            obs[types] = vals
          } else {
            obs[types] = i.value
          }
        } else {
          const typeObj = i.FormList.find(item => item.name === i.conditionValue.split('_custom')[0])
          if (typeObj && typeObj.datatype === 'custom') {
            paramsLists.push({ name: typeObj.name, value: i.value })
          }
        }
      } else {
        if (item.link !== 3) {
          const typeI = i.FormList.findIndex(its => {
            return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
          })
          if (typeI !== -1) {
            const typeObj = i.FormList[typeI]
            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
            const data = (i.value ? i.value : val) || ''
            if (typeObj.datatype === 'custom') {
              paramsLists.push({ name: typeObj.name, value: data })
            } else {
              obs[type] = data
            }
          }
        }
      }
    }
    return { obs, paramsLists }
  }

  const dealInside = async (row, config, listValue = []) => {
    // 处理选择站内应用
    // datatype 1表单 5仪表盘 7 报表应用
    const item = JSON.parse(JSON.stringify(config))

    const user = localStorage.getItem('user')
    const type = 'detailed'
    item.link = item.link || 2
    item.value = row
    item.listValue = listValue
    // ai直接传入搜索结果
    if (config.channel && config.channel === 'ai') {
      item.value = config.value
    } else if (config.channel && config.channel === 'appAi') {
      if (item.linked && item.linked.length > 0) {
        const linkedFields = item.linked;
        linkedFields.forEach(linkedField => {
          const valueKey = `${linkedField.title}_${linkedField.type}`;
          if (Object.prototype.hasOwnProperty.call(item.value, valueKey)) {
            linkedField.value = item.value[valueKey];
          }
        });
      }
    }
    console.log("item11==", item);
    if (item.appIid === 11 && item.datatype === 1 && item.insideAdd && ((item.insideAdd.customize && item.insideAdd.customize.length !== 0) || (item.insideAdd.from && item.insideAdd.from.length !== 0))) {
      // 表单
      const info = {
        config: item.insideAdd,
        row: row,
        approvalId: props.id,
      }
      localStorage.setItem('insideAdd', JSON.stringify(info))
    }
    if (skey && !user) {
      const flag = await getAppInfo(item.appid, item.datatype)
      if (!flag) {
        ElMessage.error('该应用未开放')
        return
      }
      if ((flag.loginstatus === 1 && item.appIid === 11 && flag.loginaction === 0)) {
        // 填写前注册 或者是 打开了查询登录
        emit('open-login', { row, item }, props.elId)
        return
      } else if (flag.loginstatus === 1 && item.appIid === 11 && flag.loginaction === 1) {
        // 提交前注册
        await getWebsiteUserInfo(item.appIid)
        openfunctionValue.value = flag
      } else if (flag.searchstatus === 1) {
        emit('open-login', { row, item }, props.elId)
        return
      } else if (flag.loginstatus === 0 && item.appIid === 11) {
        await getWebsiteUserInfo(item.appIid)
      }
    }
    const iId = item.appIid
    const validateList = [11, 1, 7, 6]
    if (validateList.indexOf(iId) !== -1 && item.datatype === 1) {
      const obj = {
        11: 1,
        1: 2,
        7: 3,
        6: 4
      }
      const payload = { type: obj[iId], approvalId: item.appid }
      const upaceId = isUpace ? (route.query.upaceid || localStorage.getItem('upaceid')) : undefined
      const flag = await isValidateapprovaltimeswitch(payload, upaceId)
      if (flag) return
    }
    // 只有选择了一条数据才可以点击
    if (item.datatype !== 2 && item.link === 2 && !skey && !Number.isNaN(Number(item.appIid))) {
      const getPermissions = await getApper(item)
      const permissions = purviewObj[item.appIid]
      if (!getPermissions) return
      if (getPermissions.code === 0 && Array.isArray(getPermissions.data)) {
        const pInd = getPermissions.data.findIndex(its => its.key === permissions)
        if (pInd === -1) {
          ElMessage.error('您无权限查阅该页面!')
          return
        }
      }
    }
    if (item.datatype === 1 && (item.appIid === 18 || item.appIid === 17)) {
      delLastrecentdata(item, type)
      return
    }
    if (item.open === 3) {
      // 当前页面
      const str = await getOpenUrl(item, type)
      const url = window.location.origin
      window.open((item.link !== 3 ? url : '') + str, '_blank')
    } else if (item.open === 2 || item.open === 5) {
      // 弹窗
      // 如果是站内，并选择了应用-提交
      if (item.link === 2 && item.datatype !== 5 && item.datatype !== 7 && item.appIid === 11) {
        const str = await getField(item, type)
        const popUps = {
          ...item.popUps,
          open: item.open
        }
        openAppInitiate({ ...str, iId: item.appIid, id: item.id, popUps, openfunction: openfunctionValue.value, pageType: config.pageType || '' })
      } else {
        const str = await getOpenUrl(item, type)
        const org = {
          15: true, // 打开个人最新数据
          16: true, // 打开全部最新数据
          23: true, // 打开个人最新数据
          24: true, // 打开全部最新数据
          13: true, // 修改个人最新数据
          14: true // 修改全部最新数据
        }
        if (org[item.appIid]) {
          const popUps = {
            ...item.popUps,
            open: item.open
          }
          openAppInitiate({ approvalId: item.appid, name: item.name, search: str, iId: item.appIid, datatype: item.datatype, id: item.id, popUps, pageType: config.pageType || '' })
        } else {
          const obj = {
            2: 'dialog',
            3: 'new',
            4: 'old',
            5: 'rightdia'
          }
          dialogInfo.value = {
            isVisible: true,
            dialogName: '',
            dialogWidth: item.popUps.w + 'px',
            dialogHeight: item.popUps.h + 'px',
            openType: obj[item.open],
            customSize: item.popUps.customSize,
            diaSize: item.popUps.diaSize,
            dialogUrl: str,
            openfunction: openfunctionValue.value,
            isShowDialog: item.isShowDialog === false ? false : true
          }
          if (item.channel && item.channel === 'appAi') {
            openAppDialog(dialogInfo.value)

          }
          emit('open-appDialog', dialogInfo.value)
        }
      }
    } else if (item.open === 4) {
      // 新页面
      const str = await getOpenUrl(item, type)
      window.location.href = str
    }
  }

  const getUserInfo = async (id) => {
    const res = await apiGetmiddleuserbyid({ userId: id }).catch(err => { console.log(err) })
    if (res.code === 0) return res.data
  }
  const getTime = (str, format) => {
    if (!str || str === 0) return ''
    if (!format) return str
    const date = new Date(str)
    const obs = {
      YYYY: date.getFullYear(),
      MM: date.getMonth() + 1,
      DD: date.getDate()
    }
    return format.split('/').map(item => obs[item]).join('/')
  }

  const getApper = async (item) => {
    const obj = {
      appid: item.appid,
      datatype: item.datatype
    }
    // 从空间进入，需要传空间id
    if (isSpace) {
      let spaceId = typeof (route.query.spaceid) !== 'undefined' ? route.query.spaceid : localStorage.getItem('spaceid')
      obj.spaceid = spaceId;
    }
    else if (isUpace) {
      let upaceId = typeof (route.query.upaceId) !== 'undefined' ? route.query.upaceId : localStorage.getItem('upaceId')
      obj.upaceid = upaceId;
    }
    if (route.query.spaceid) {
      obj.spaceid = route.query.spaceid
    }
    else if (route.query.upaceid || localStorage.getItem('upaceid')) {
      obj.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
    }
    const res = await getappperAuthority(obj).catch(err => { console.log(err) })
    if (item.datatype !== 2) {
      return res
    }
    if (res.code === 0 && res.data.per) {
      return res.data.pcUrl
    } else {
      ElMessage.warning(res.msg || '暂无权限!')
    }
    return false
  }

  // 根据配置查询 本表和自定义 数据
  const getField = async (item, type) => {
    console.log('当前要跳转的', item, type)
    let goObj = {
      url: item.url
    }
    switch (item.link) {
      case 1:
        goObj = {
          ...goObj,
          url: '/clientSide/instrument/instrument',
          dataReportId: route.query.dataReportId,
          showId: item.id
        }
        break
      case 2:
        if (type === 'detailed') {
          // 5 是 仪表盘的
          if (item.datatype === 5) {
            goObj = {
              ...goObj,
              url: '/clientSide/instrument/instrument',
              dataReportId: item.appid,
              showSearch: true
            }
            if (item.open === 4) goObj.navShow = 'true'
          } else {
            goObj = {
              ...goObj,
              url: '/clientSide/application',
              approvalId: item.appid,
              iId: item.appIid,
              source: 'user',
              name: item.appName,
              navShow: false
            }
            goObj[goAppId[item.appIid]] = item.appIid
          }
        } else {
          goObj = {
            ...goObj,
            url: '/clientSide/application',
            approvalId: item.appid,
            source: 'user',
            name: item.appName
          }
          if (item.open === 2 || item.open === 5) goObj.navShow = false
        }
        break
    }
    if (item.link === 2) {
      // 应用的话单独配置
      console.log('应用的单独配置2', item, item.linked)
      if (props.cardUser && JSON.stringify(props.cardUser) !== '{}') item.value = { ...item.value, ...props.cardUser }
      let obs = {}
      const screenLinked = []
      const filedLinked = []
      const otherLinked = []
      for (const i of item.linked) {
        if (i.orgName === 'screen') {
          screenLinked.push(i)
        } else if (i.orgName === 'filed' || i.orgName === undefined) {
          filedLinked.push(i)
        } else {
          otherLinked.push(i)
        }
      }
      if (otherLinked.length !== 0) {
        const obj = getOtherLinked({ linked: otherLinked, currentOrg: props.currentOrg, currentUser: props.currentUser })
        obs = { ...obs, ...obj }
      }
      console.log(filedLinked, screenLinked, 'filedLinked, screenLinked', otherLinked);

      if (screenLinked.length !== 0) {
        const screens = (props.screenRef && props.screenRef.length > 0 ? props.screenRef : props.$refs.screenRef) || []
        if (props.otherToolScreenRef && props.otherToolScreenRef.length > 0) {
          screens.push(...props.otherToolScreenRef)
        }
        const currentOrg = props.currentOrg
        const customData = props.customData
        const obj = getInsideScreenParam({ screenLinked, screens, currentOrg, customData, orgList: props.orgList })
        obs = { ...obs, ...obj }
      }
      let beforeTick = 0
      for (const i of filedLinked) {
        let val = ''
        if (i.datatype === 'custom') {
          // 自定义的变量
          val = getCustomVal(i)
        } else {
          val = item.value ? (item.value[filterSymbol(i.title)] || item.value[filterSymbol(i.name)]) : ''
          // ai小易把匹配的字段都传入
          if (item.channel && item.channel === 'ai' && item.value) {
            const matchingRule = i.FormList.find(rule => rule.name === i.conditionValue);
            val = item.value[filterSymbol(i.title + '_' + i.type)]
            if (filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && val && val.content) {
              val = val.content
            }
            // 富文本控件把markdown转成html格式
            if (filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && matchingRule && matchingRule.type === 'richTextWid') {
              val = markdownToHtml(val)
            }
            else if (filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && matchingRule && matchingRule.type !== 'richTextWid') {
              // 非富文本控件，去除markdown格式，转换为纯文本
              val = markdownToText(val)
            }
            console.log("val--", val)
          }
        }

        if (i.title === '申请人' && i.name === '申请人') {
          val = [{
            realname: val,
            userId: item.value.userId
          }]
          // 不敢改以前的逻辑 只能判断错的情况下这样处理
          const _val = item.value[filterSymbol(i.title || i.name)]
          if (item.value.userId === undefined && Array.isArray(_val)) {
            val = _val
          }
        }
        if (i.type === 'relation-user' && val && typeof val === "string") {
          if (item.channel && item.channel === 'ai') {
            val = JSON.parse(val)
          }
          else {
            val = ''
          }
          // 如果联系人数据是个字符串就置空
          if (item.channel && item.channel === 'ai' && item.value) {
            val = JSON.parse(item.value[filterSymbol(i.title + '_' + i.type)])
          }
        } else if (i.type === 'relation-user' && val && typeof val === "object") {
          // 去发起直接回去整个结构，不特殊处理
          if (item.appIid === 11 && item.datatype === 1) {
            // TODO
          } else {
            const typeI = i.FormList.findIndex(its => {
              return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
            })
            const typeObj = i.FormList[typeI]

            // 这里是没有的自定义那种指定输出内容的，所以全部直接匹配(选择对象是申请人表示是搜索的，其他的直接返回整个人员数据)
            if (Array.isArray(val)) {
              val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? val.map(its => its.realname || its.name).join('') : val
            } else {
              val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? val.realname : val
            }
          }
        } else if (i.type === 'date') {
          val = await getTime(val, i.format)
        }
        const typeI = i.FormList.findIndex(its => {
          return its.name === i.conditionValue.split('_')[0]
        })
        const typeObj = i.FormList[typeI]
        let type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
        if (typeObj.fatherType && typeObj.fatherType.includes('details')) {
          type = `${type}--${typeObj.name}`
        }
        // 如果原来值存在的话，就判断格式转成数组，是数组的话则直接添加
        if (typeObj.fatherType && typeObj.fatherType.includes('ready-widget')) {
          const parentType = typeObj.fatherType.split('.')[0]
          let obj = {}
          const timeType = typeObj.timeType || 'start'
          if (typeObj.type === 'dates' && i.type === 'date') {
            const formItem = i.FormList.find(its => its.type === 'displaylist')
            const type = `${typeObj.title}_${typeObj.type}`
            const [day, time] = val.split(' ')
            const timeArr = TIME_10_30_60[typeObj.tick || 30]
            let timeIndex = timeArr.findIndex(its => its === time)
            if (timeIndex > 0) {
              timeIndex--
            }
            const displayListKey = `${formItem.title}_${formItem.type}`
            if (obs[parentType]) {
              obj = obs[parentType][0]
              if (obj[type]) {
                obj[type].push(day)
              } else {
                obj[type] = [day]
              }
              const isOnTheSameDay = obj[type].some(its => its === day)
              if (isOnTheSameDay && obj[displayListKey]) {
                // 预约的是同一天
                if (obj[displayListKey][0].time.length === 1) {
                  if (timeType === 'start') {
                    obj[displayListKey][0].time[0] = timeIndex
                  } else if (timeType === 'end') {
                    obj[displayListKey][0].time[1] = timeIndex
                  }
                }
              } else if (obj[displayListKey]) {
                // 预约的是不同的一天
                const displayList = {
                  tick: typeObj.tick || 30,
                  date: day,
                  time: []
                }
                if (timeType === 'start') {
                  displayList.time[0] = timeIndex
                } else if (timeType === 'end') {
                  displayList.time[1] = beforeTick
                }
                obj[displayListKey].push(displayList)
              } else {
                obj[displayListKey] = [{
                  tick: typeObj.tick || 30,
                  date: day,
                  time: [timeIndex]
                }]
              }
            } else {
              // 没有预约控件值
              obj[type] = [day]
              obj[displayListKey] = [{
                tick: typeObj.tick || 30,
                date: day,
                time: []
              }]
              if (timeType === 'start') {
                obj[displayListKey][0].time[0] = timeIndex
              } else if (timeType === 'end') {
                obj[displayListKey][0].time[1] = timeIndex
              }
              beforeTick = timeIndex
            }
          } else {
            const type = `${typeObj.title}_${typeObj.type}`
            if (obs[parentType]) {
              obj = obs[parentType][0]
            }
            obj[type] = val
          }
          obs[parentType] = [obj]
        } else {
          if (obs[type]) {
            if (Array.isArray(obs[type])) {
              obs[type].push(val)
            } else {
              obs[type] = [obs[type], val]
            }
          } else {
            if (!val && i.fatherType && i.fatherType.includes('details')) {
              const it = i.fatherType.split('.')
              if (item.value[it[0].split('_')[0]]) {
                val = typeof item.value[it[0].split('_')[0]] === 'string' ? JSON.parse(item.value[it[0].split('_')[0]])[0][`${i.title}_${i.type}`] : item.value[it[0].split('_')[0]][0][`${i.title}_${i.type}`]
              }
            }
            obs[type] = val || ''
          }
        }
      }
      for (const i of item.customize) {
        console.log('自定义遍历', i)
        let val = item.value[i.title || i.name]
        if (i.type === 'relation-user' && typeof val === "object") {
          if (i.format === 'userId' || i.format === 'realname') {
            val = val[i.format]
          } else {
            console.log('查询1', item.user, i.name)
            if (Array.isArray(val)) {
              val = []
              for (const s of val) {
                const user = await getUserInfo(s.userId)
                val.push(user[i.format])
              }
            } else {
              const user = await getUserInfo(val.userId)
              val = user[i.format]
            }
          }
        } else if (i.type === 'date') {
          val = await getTime(val, i.format)
        }
        if (item.datatype === 5) {
          // 仪表盘另外算
          const types = i.FormList[i.index].i
          if (obs[types]) {
            const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
            obs[types] = vals
          } else {
            obs[types] = val
          }
        } else {
          const typeI = i.FormList.findIndex(its => {
            return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
          })
          const typeObj = i.FormList[typeI]
          let type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
          // 传值是变量
          if (typeObj && typeObj.datatype === 'custom' && item.datatype === 1) {
            type = typeObj.name + '_' + typeObj.type + '_custom'
          }
          if (i.value) {
            obs[type] = i.value || ''
          } else {
            obs[type] = val || ''
          }
        }
      }
      if (JSON.stringify(obs) !== '{}') {
        const detailObj = {}
        const detObs = {}
        for (const key in obs) {
          let end = item.linked.find(f => f.conditionValue === key.split('--')[1])
          if (end) {
            // 单独处理明细
            const realname = end.conditionValue
            const formList = end.FormList
            const endItem = formList.find(item => item.name === realname)
            if (endItem && endItem.fatherType) {
              const endName = endItem.fatherType.split('.')
              const endItemName = end.fatherType.split('.')
              const [fatherItemTitle, fatherItemType] = endItemName[0].split('_')
              const [fatherTitle, fatherType] = endName[0].split('_')
              const [title, type] = endName[1].split('_')
              const obj = {
                fatherTitle,
                fatherType,
                title,
                type,
                targetTitle: end.title,
                targetType: end.type,
                resTitle: end.title,
                resType: end.type,
                val: obs[key]
              }
              const fatherKey = `${fatherTitle}_${fatherType}`
              if (detailObj[fatherKey] === undefined) {
                detailObj[fatherKey] = {
                  type: `${fatherItemTitle}_${fatherItemType}`,
                  val: [obj]
                }
              } else {
                detailObj[fatherKey].val.push(obj)
              }
            }
            delete obs[key]
          }
        }
        for (const key in detailObj) {
          let mapValue = item.detailValue || [item.value]
          for (const cVal of mapValue) {
            const val = cVal[detailObj[key].type.split('_')[0]]
            const detail = detailObj[key]
            if (val) {
              try {
                let data = typeof val === 'string' ? JSON.parse(val) : val
                data = data.filter(f => !Array.isArray(f)).map(f => {
                  const obj = {}
                  detail.val.forEach(c => {
                    let res = `${c.resTitle}_${c.resType}`
                    const valRes = `${c.title}_${c.type}`
                    if (c.val) {
                      res = valRes
                    }
                    obj[res] = f[`${c.resTitle}_${c.resType}`] || c.val || f[valRes]
                  })
                  return obj
                })
                if (detObs[key]) {
                  detObs[key].push(...data)
                } else {
                  detObs[key] = data
                }
              } catch (error) {
                const obj = {}
                detail.val.forEach(c => {
                  obj[[`${c.title}_${c.type}`]] = cVal[c.targetTitle]
                })
                if (detObs[key]) {
                  detObs[key].push(obj)
                } else {
                  detObs[key] = [obj]
                }
              }
            }
          }
        }
        goObj.search = {
          ...obs,
          ...detObs
        }
      }
    } else {
      const obs = {}
      for (const i of item.customize) {
        let val = item.value[i.title || i.name]
        if (i.type === 'relation-user' && typeof val === "object") {
          if (i.format === 'userId' || i.format === 'realname') {
            val = val[i.format]
          } else {
            console.log('查询2', item.user, i.name)

            const user = await getUserInfo(val.userId)
            val = user[i.format]
          }
        } else if (i.type === 'date') {
          val = await getTime(val, i.format)
        }
        if (i.parameter) {
          obs[i.parameter] = val
        } else {
          obs[i.title + '_' + i.type] = val
        }
      }
      if (JSON.stringify(obs) !== '{}') {
        goObj = {
          ...goObj,
          ...obs
        }
      }
    }
    return goObj
  }

  const delLastrecentdata = (item, type) => {
    ElMessageBox.confirm('确定要删除？', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      // 删除
      const str = await getField(item, type)
      const obj = {
        type: item.appIid === 18 ? 0 : 1,
        approvalId: str.approvalId
      }
      if (str.search) {
        obj.query = {}
        for (const s in str.search) {
          // 空数据不管
          if (str.search[s] || str.search[s] === 0) {
            const val = str.search[s]
            if (Array.isArray(val)) {
              obj.query[s] = val
            } else {
              obj.query[s] = [val]
            }
            // 做一次空置去除
            obj.query[s] = obj.query[s].filter(its => its || its === 0)
          }
        }
      }
      if (obj.query) obj.query = JSON.stringify(obj.query)
      // console.log('拼接完毕', obj)
      const res = await deletelastrecentdata(obj).catch(err => { console.log('删除错误', err) })
      if (res.code === 0) {
        //  TODO 刷新列表
        emit('updateTable', {})
        ElMessage({
          type: 'success',
          message: '删除成功!'
        });
      } else {
        ElMessage({
          type: 'error',
          message: res.msg
        });
      }
    })
  }


  const getImportData = async (obj) => {
    // 获取当前页面过滤条件的前1000条数据
    const otherConfig = {
      isGetData: true,
      saveKey: 'importData',
      currentPage: 1,
      pagesize: 1000
    }
    this.importConfig = obj
    if (obj.dataFrom === 3 && obj.time) {
      // 获取指定时间内前1000条数据
      otherConfig.query = { date_timeof: obj.time }
    }
  }

  const openAppDialog = async (val) => {
    // 数据导入的特殊处理
    if (val.dialogUrl.search('TMbulkImport') !== -1) {
      if (val.dataFrom) {
        if (val.AiDropData) {
          importLinked(val.info.info, null, val.chooseField || [], val.AiDropData)
        } else {
          await getImportData(val.dialogUrl)
        }
      } else {
        const queryStr = getQueryStr(val.dialogUrl)
        if (queryStr.isUpdateById === 'true') {
          await getImportAllData(queryStr)
        }
      }
    }
    dialogInfo.value = val
  }

  const getImportAllData = async (obj) => {
    // 获取当前页面过滤条件的前1000条数据
    // const otherConfig = {
    //   isGetData: true,
    //   saveKey: 'importData',
    //   currentPage: 0,
    //   pagesize: 0
    // }
    importConfig.value = obj
    if (this.listInfo.tableData.length === props.listInfo.tableTotal) {
      importData.value = props.listInfo.tableData
      toImportData()
    } else {
      // await this.handleListInfo(this.dataInfo.pageId, this.isSearchStatus ? this.searchText : '', this.querys, '0', {}, otherConfig)
    }
  }

  const toImportData = () => {
    if (importConfig.value.isUpdateById === 'true') {
      localStorage.setItem('importAllData', JSON.stringify(importData.value))
    } else if (importConfig.value && importConfig.value.dataFrom !== 1) {
      this.importLinked(importConfig.value.info.info, importData.value, importConfig.value.chooseField || [])
    }
  }

  const getQueryStr = (str) => {
    let queryStr
    try {
      queryStr = decodeURIComponent(str).split('?')[1]
    } catch (error) {
      queryStr = str.split('?')[1]
    }
    try {
      queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
      queryStr = qs.parse(queryStr, {
        decoder: (str) => decodeURIComponent(str.replace(/\+/g, '%2B'))
      })
    } catch (error) {
      queryStr = queryStr.replace(/&gt;/g, '>').replace(/&lt;/g, '<');
      queryStr = qs.parse(queryStr)
    }
    return queryStr
  }

  const openAppInitiate = ({ approvalId, name, search, iId, id, datatype, popUps, openfunction }) => {
    if (openfunction) {
      openfunctionValue.value = openfunction
    }
    const openInput = {
      isVisible: true,
      approvalId: approvalId,
      name: name,
      search: search,
      iId: iId,
      isDetail: iId === 15 || iId === 16 /*|| iId === 13 || iId === 14*/,
      id: id || '',
      datatype: datatype
    }
    appId.value = approvalId
    iIdValue.value = iId
    openInputValue.value = openInput
    const obj = {
      2: 'dialog',
      3: 'new',
      4: 'old',
      5: 'rightdia'
    }
    dialogInfo.value = {
      isVisible: true,
      dialogName: name,
      dialogWidth: popUps.w + 'px',
      dialogHeight: popUps.h + 'px',
      openType: obj[popUps.open],
      customSize: popUps.customSize,
      diaSize: popUps.diaSize,
    }
    addInputShow.value = true
  }

  const importLinked = async (info, dataList, chooseField = [], AiDropData) => {
    chooseField = cloneDeep(chooseField)
    const allInCustomInfo = info.allInCustomInfo
    let isCustomHeader = false
    let customHeaderList = []
    console.log(allInCustomInfo, 'allInCustomInfo')
    if (allInCustomInfo) {
      if (allInCustomInfo.importType === 'table') {
        if (info.allInCustomInfo.valueKey === 0) {
          chooseField.push({ title: '单号', type: 'text' })
        } else {
          info.allInCustomInfo.valueSearchList.forEach(item => {
            const [title, type] = item.split('_')
            chooseField.push({ title, type })
          })
        }
      }
      // 处理列转行的数据传参
      if (allInCustomInfo.importHeaderType === 'custom') {
        isCustomHeader = true
        customHeaderList = allInCustomInfo.customHeaderInfo.rowHeadName.split(',')
      }
    }

    if (info.insideInfo && info.insideInfo.linked) {
      let date = []

      if (AiDropData) {
        date = AiDropData
      } else {
        if (!dataList) {
          dataList = cloneDeep(props.multipleSelection)
        }
        if (dataList.length > 0) {
          for (const ele of dataList) {
            const data = await getObs(info.insideInfo, ele)
            const obj = {}
            chooseField.forEach(item => {
              obj[`${item.title}_${item.type}`] = ele[item.title]
            })
            if (isCustomHeader) {
              const eleKeys = Object.keys(ele)
              customHeaderList.forEach(item => {
                const key = eleKeys.find(iten => { return iten.search(`.${item}`) !== -1 && iten.search('approving_id') === -1 })
                if (key) {
                  obj[item] = ele[key]
                }
              })
            }
            date.push({ ...obj, ...data.obs })
          }
        } else {
          const data = await getObs(info.insideInfo, {})
          date.push(data.obs)
        }
      }
      if (date.length > 0) {
        if (chooseField.length === 0) {
          const defaultObj = getDefaultObj(info.insideInfo, date[0]) || {}
          if (Object.keys(defaultObj).length > 0) {
            localStorage.setItem('defaultDataObs', JSON.stringify(defaultObj))
          }
        }
        localStorage.setItem('TMbulkImportObs', JSON.stringify(date))
      }
    }
  }

  return {
    dealInside,
    dialogInfo,
    openInputValue,
    iIdValue,
    addInputShow
  }
}